"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertFontWeightToType = exports.cleanText = void 0;
var convertFontWeightToType = exports.convertFontWeightToType = function convertFontWeightToType(fontWeight, fontStyle) {
  var isBold = false;
  var isItalic = false;
  if (fontWeight && /bold|700/i.test(fontWeight)) {
    isBold = true;
  }
  // paper.js exports the italic value as part of the fontWeight attribute
  if (fontWeight && /italic/i.test(fontWeight)) {
    isItalic = true;
  }
  if (fontStyle && /italic/i.test(fontStyle)) {
    isItalic = true;
  }
  return isBold && isItalic ? 'boldItalic' : isBold ? 'bold' : isItalic ? 'italic' : 'regular';
};
var cleanText = exports.cleanText = function cleanText(text) {
  return text.replace(new RegExp(String.fromCharCode(160), 'g'), ' ');
}; // replace nbsp with space